import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CheckinHistoryRoutingModule } from './checkin-history-routing.module';
import { CheckinHistoryComponent } from './checkin-history.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';


@NgModule({
  declarations: [CheckinHistoryComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgZorroAntdModule,
    ReactiveFormsModule,
    SharedModule,
    CheckinHistoryRoutingModule
  ]
})
export class CheckinHistoryModule { }
